$(document).ready(function(e) {			
	
	$('ul.mainMenu li a').click(function(event) {
		event.preventDefault();
		var ids = $(this).attr('href');
		 $('html, body').animate({
			scrollTop: $(ids).offset().top - 50
		}, 2000);
	});
	
	$(".packg").click(function() {
		$('html, body').animate({
			scrollTop: $("#select_pkg").offset().top - 50
		}, 2000);
	});
	
	$('.s3_box').slick({
		dots: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,			
		autoplaySpeed:5000,
//		variableWidth: true,
//		centerMode: true,
		responsive: [
		
		{
			breakpoint: 9999,
			settings: "unslick"
		
		},
		
		{
			breakpoint: 1550,
			settings: {
				slidesToShow:4,
				slidesToScroll: 1,
				dots: true,
			}
		},
		{
			breakpoint: 1200,
			settings: {
				slidesToShow:3,
				dots: true,
			}
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow:2,
				dots: true,
			}
		},
		{
			breakpoint: 767,
			settings: "unslick"
		},
		]
	});	
	
	
	$('.testi_slider').slick({
		dots: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
//		variableWidth: true,
//		centerMode: true,
		responsive: [
		
		{
			breakpoint: 1021,
			settings: {
				slidesToShow:2,
			}
		},
		{
			breakpoint: 767,
			settings: {
				dots: true,
				slidesToShow:1,
				variableWidth: true,
				centerMode: true,
			}
		},
		]
	});	
	

//accordion JS 
	$(".acdn-heading").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
});


$(document).scroll(function() {
			
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
});

//MODAL Shades
function openModal() {
  document.getElementById('shadeModal').style.display = 'block';
}

function closeModal() {
  document.getElementById('shadeModal').style.display = 'none';
}

// Optional: Close the modal if the user clicks outside of it
window.onclick = function(event) {
  let modal = document.getElementById('shadeModal');
  if (event.target == modal) {
    closeModal();
  }
}